export default {
  title: 'Billing Checklist',
  dateFilter: {
    selectRange: 'Select Date Range',
    today: 'Today',
    yesterday: 'Yesterday',
    singleDate: 'Single Date',
    selectDate: 'Select Date',
    last7Days: 'Last 7 Days',
    last30Days: 'Last 30 Days',
    customRange: 'Custom Range',
    all: 'All',
    currentMonth: 'This Month',
    startDate: 'Start Date',
    endDate: 'End Date',
    to: 'to'
  },
  sync: {
    title: 'Sync',
    noSelection: 'No Items Selected',
    selectItems: 'Please select items to sync',
    success: 'Successfully synced with QuickBooks',
    completed: 'Selected items have been synced successfully',
    error: 'Sync Error',
    failed: 'Failed to sync with QuickBooks',
    pending: 'Pending sync',
    manual: 'Manually processed',
    resend: 'Send Again'
  },
  loadNew: {
    title: 'Load New',
    success: 'Load Successful',
    completed: 'New items loaded',
    added: 'added',
    skipped: 'skipped',
    pending: 'more pending (run Load New again)',
    errors: 'errors',
    error: 'Load Error',
    failed: 'Failed to load new items',
    alreadyProcessing: 'Already Processing',
    alreadyProcessingDesc: 'Another load request is already in progress'
  },
  retry: {
    success: 'Retry Successful',
    completed: 'QB customer link found and data updated successfully',
    error: 'QB Link Missing',
    failed: 'Customer not linked to QuickBooks yet. Please link them in QuickBooks Sync Review first.'
  },
  retryAll: {
    title: 'Retry All',
    success: 'Retry All Successful',
    completed: 'Bulk retry completed',
    updated: 'updated',
    notFound: 'not found',
    error: 'Retry All Error',
    failed: 'Failed to retry items'
  },
  types: {
    all: 'All',
    device: 'Devices',
    service: 'Services',
    'no-qbo': 'No QB Link',
    'credits': 'Credits',
    hidden: 'Hidden'
  },
  status: {
    pending: 'Pending',
    done: 'Done',
    others: 'Others',
    hidden: 'Hidden'
  },
  columns: {
    select: 'Select All',
    customer: 'Customer',
    total: 'Total',
    price: 'Price',
    status: 'Status',
    paymentStatus: 'Payment Status',
    createdAt: 'Date',
    details: 'Details',
    location: 'Location'
  },
  paymentStatus: {
    title: 'Payment Status',
    paid: 'Paid',
    partial: 'Partial',
    due: 'due',
    unpaid: 'Unpaid',
    overdue: 'Overdue',
    voided: 'Voided',
    free: 'Free',
    dueSoon: '<12h',
    left: 'left',
    overdueTooltip: 'Payment overdue! Customer must pay invoice.',
    dueSoonTooltip: 'Due soon within 12 hours',
    voidedTooltip: 'Invoice was voided in QuickBooks',
  },
  
  details: {
    nocApproved: {
      label: 'NOC approval for devices',
      yes: 'NOC approved',
      no: 'Awaiting NOC',
    },
    title: 'Billing Details',
    customerInfo: {
      title: 'Customer Information',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      customerType: 'Customer Type',
      customerId: 'Customer ID',
      deltaId: 'Delta ID',
      nid: 'NID',
      companyName: 'Company Name',
      licenseNo: 'License No',
      activity: 'Business Activity',
      address: 'Address',
      internetUsage: 'Internet Usage',
      internetPurpose: 'Usage Purpose',
      previousPackage: 'Previous Package',
      familiarityWithUs: 'How Found Us'
    },
    devices: {
      title: 'Unpaid Devices',
      name: 'Device Name',
      quantity: 'Quantity',
      unitPrice: 'Unit Price',
      total: 'Total',
      totalPrice: 'Total Device Price'
    },
    package: {
      title: 'Unpaid Package',
      name: 'Package Name',
      period: 'Service Period',
      price: 'Package Price'
    },
    total: {
      title: 'Total Amount',
      amount: 'Amount',
      readonly: 'Price locked'
    },
    totalAmount: 'Total Unpaid Amount'
  },
  actions: {
    title: 'Actions',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    check: 'Check',
    approve: 'Approve',
    reject: 'Reject',
    cancel: 'Cancel',
    resend: 'Send',
    tryAgain: 'Try Again',
    retryQbLink: 'Retry QB Link',
    registerInQb: 'Complete QB Registration',
    recheck: 'Recheck / Fix Invoice',
    setManual: 'Set as Manual',
    unsetManual: 'Unset Manual',
    hide: 'Hide',
    unhide: 'Unhide',
    invoiceMemo: 'Invoice memo',
    history: 'Change History',
    payment: 'Payment Page',
    refreshCredit: 'Retrieve Available Credit',
  },
  history: {
    title: 'Change Log & Audit Trail',
    description: 'Review user modifications made to this billing record.',
    originalValues: 'Original Values',
    currentValues: 'Current Values',
    edited: 'Edited',
    loading: 'Loading change history…',
    noChanges: 'No change logs recorded for this item.',
    noChangesSub: 'Modifications to discount, price, or memo will appear here.',
    unknownUser: 'System / Unknown',
    close: 'Close',
    fields: {
      totalPrice: 'Total Price',
      discount: 'Discount',
      memo: 'Invoice Memo',
    }
  },
  memo: {
    title: 'Invoice Memo',
    description: 'Optional QuickBooks invoice message. ',
    placeholder: 'Write invoice memo…',
    save: 'Save',
    apply: 'Apply',
    done: 'Done',
    cancel: 'Cancel',
    close: 'Close',
    saved: 'Invoice memo saved',
    savedQbo: 'Invoice memo saved and updated in QuickBooks',
    error: 'Failed to save invoice memo',
  },
  dialog: {
    confirm: {
      title: 'Confirm Action',
      approveMessage: 'Are you sure you want to approve this item?',
      rejectMessage: 'Are you sure you want to reject this item?'
    }
  },
  notifications: {
    approved: {
      title: 'Approved',
      description: 'Credit check has been approved.'
    },
    rejected: {
      title: 'Rejected', 
      description: 'Credit check has been rejected.'
    },
    error: {
      title: 'Error',
      description: 'Failed to process credit check. Please try again.',
      fetchError: 'Failed to fetch checklist items. Please try again.'
    },
    hidden: {
      title: 'Hidden',
      hideDescription: 'Item has been hidden successfully.',
      unhideDescription: 'Item has been unhidden successfully.'
    },
    manual: {
      title: 'Manual Status',
      description: 'Manual status updated successfully.'
    },
    saved: {
      title: 'Saved',
      description: 'Device prices updated successfully.'
    }
  },
  devicePricesPopover: {
    panelTitle: 'Device prices — {count} item(s)',
    device: 'Device',
    qty: 'Qty',
    catalog: 'Catalog',
    unitPrice: 'Unit (AFN)',
    subtotal: 'Subtotal',
    total: 'Total',
    discount: 'Discount',
    net: 'Net',
    unknownDevice: 'Unknown device',
    saveError: 'Failed to update device price'
  },
  search: {
    minChars: "Please enter at least 3 characters to search",
    placeholder: "Search by name, ID, contract, service, center..."
  },
  applyCredits: {
    title: 'Apply Payment to Invoice',
    triggerTitle: 'Apply Credit',
    loading: 'Loading invoice and credit information...',
    selectInvoice: 'Select an open invoice for this customer',
    noOpenInvoices: 'No open invoices found for this customer.',
    selectCredit: 'Select available credit (payment)',
    noCredits: 'No available credits or open payments found for this customer.',
    creditsAvailable: 'CREDITS AVAILABLE:',
    creditsToApply: 'Credits to Apply',
    openAmount: 'Open Amount',
    current: 'Current',
    overdue: 'Overdue',
    memo: 'Memo',
    applyButton: 'Apply Credit',
    cancel: 'Cancel',
    success: 'Credit Applied',
    applied: 'Successfully applied {amount} to invoice',
    error: 'Error',
    loadFailed: 'Failed to load invoice and credits data',
    applyFailed: 'Failed to apply credits'
  },
  refreshCredit: {
    title: 'Retrieve Available Credit',
    success: 'Credit Retrieved',
    error: 'Retrieve Error',
    failed: 'Failed to retrieve customer available credit',
  },
  refresh: {
    title: 'Refresh Cache',
    success: 'Cache cleared and data refreshed successfully',
    error: 'Failed to refresh cache'
  },
  classify: {
    title: 'Classify',
    dialogTitle: 'Classify Selected Items',
    dialogDescription: 'Select a QuickBooks class and/or location to classify the selected checklist items.',
    class: 'QuickBooks Class',
    location: 'QuickBooks Location',
    selectClass: 'Select a class',
    selectLocation: 'Select a location',
    noChange: '(No Change)',
    selectedCount: 'Selected items',
    noSelection: 'No Selection',
    selectItems: 'Please select at least one item',
    selectClassOrLocation: 'Please select at least a class or location',
    success: 'Classification Applied',
    updated: 'Updated',
    items: 'items',
    with: 'with',
    error: 'Classification Error',
    failed: 'Failed to apply classification',
    cancel: 'Cancel',
    apply: 'Apply Classification'
  }
} 